import React, { useState } from "react";
import PropTypes from "prop-types";
import { behaviourNameLookup } from "@src/constants/constants";
import AppUtils from "@src/utils/appUtils";
import DrawerCard from "@src/components/cards/DrawerCard";
import { trackActionActivity } from "../../utils/userActivityTracker";

const FAQList = (props) => {
  const {
    faqDCKeys,
    eventName,
    getDynamicContentFunc,
    handleOpenOnboarding,
    exclusions,
    openQ,
    setOpenQ,
  } = props;

  const [internalOpenQ, setInternalOpenQ] = useState(null);
  const isControlled = openQ !== undefined && setOpenQ !== undefined;
  const currentOpenQ = isControlled ? openQ : internalOpenQ;

  const handleOpen = (isOpening, cardIndex) => {
    const newOpenQ = currentOpenQ === cardIndex ? null : cardIndex;
    if (isControlled) {
      if (newOpenQ) {
        trackActionActivity(`FAQ-${newOpenQ}`);
      }
      setOpenQ(newOpenQ);
    } else {
      setInternalOpenQ(newOpenQ);
    }
  };

  let tableContent = "<br/>";
  const FAQs = [];

  if (exclusions) {
    Object.keys(exclusions).forEach((bvrName) => {
      if (exclusions[bvrName].length > 0) {
        tableContent += getDynamicContentFunc(
          "faq__bvr_exc_table",
          {
            BEHAVIOUR_NAME:
              behaviourNameLookup[bvrName.toUpperCase()]?.name || bvrName,
          },
          "",
          true,
        );
        tableContent += "<br/><ul>";
        exclusions[bvrName].forEach((dimension) => {
          tableContent += `<il class="pl-8 pt-3 capitalize"> ${
            dimension.field_name
          }: <strong>${dimension.values.join(
            "</strong>, <strong>",
          )}</strong></il>`;
          tableContent += `<br/>`;
        });
        tableContent += "</ul><br/>";
      }
    });
  }

  for (let f = 0; f < faqDCKeys.length; f++) {
    //example faqDCKey = faq__cat1__q1
    const key = `${faqDCKeys[f]}-${f}`;
    const questionNumber = faqDCKeys[f].includes("charity")
      ? faqDCKeys[f].match(/__charity_q(\d+)/)[1]
      : faqDCKeys[f].match(/__q(\d+)/)[1]; // get the number after q
    const answerKey = `${faqDCKeys[f].replace(
      /_q\d+$/,
      "_a",
    )}${questionNumber}`;
    if (getDynamicContentFunc(faqDCKeys[f])) {
      const question = getDynamicContentFunc(faqDCKeys[f], {
        EVENT_NAME: eventName,
      });
      const questionString = getDynamicContentFunc(
        faqDCKeys[f],
        { EVENT_NAME: eventName },
        "",
        true,
      );

      const needsOnboardingLinkAppended =
        !!questionString &&
        (questionString.toLowerCase().trim().includes("onboarding process") ||
          questionString.toLowerCase().trim().includes("onboarding screens")) &&
        typeof handleOpenOnboarding === "function";

      const content = (
        <p className="py-3 text-gray-800">
          {getDynamicContentFunc(
            answerKey,
            { TABLE: tableContent, EVENT_NAME: eventName },
            "",
          )}
          {needsOnboardingLinkAppended && (
            <span
              className="font-bold pl-1 hover:underline cursor-pointer"
              onClick={handleOpenOnboarding}
            >
              here.
            </span>
          )}
        </p>
      );
      //only show FAQs that dont have "DO NOT SHOW" in the question. this can be used to remove question from and industry by having the industry string contain "DO NOT SHOW"
      if (!questionString.includes("DO NOT SHOW")) {
        FAQs.push(
          <DrawerCard
            key={key}
            cardIndex={key}
            isOpen={currentOpenQ === key}
            onClick={handleOpen}
            top={question}
            bottom={content}
          />,
        );
      }
    }
  }

  return <div className="w-full flex flex-col gap-4 mb-4">{FAQs}</div>;
};

export const faqListControls = {
  faqDCKeys: {
    propType: PropTypes.arrayOf(PropTypes.string),
    description: "Array of FAQ content keys",
    controlType: "object",
    defaultValue: [],
  },
  getDynamicContentFunc: {
    propType: PropTypes.func,
    description: "Function to get dynamic content",
    disable: true,
  },
  handleOpenOnboarding: {
    propType: PropTypes.func,
    description: "Onboarding handler",
    disable: true,
  },
  exclusions: {
    propType: PropTypes.object,
    description: "Excluded FAQ items",
    controlType: "object",
    defaultValue: {},
  },
  openQ: {
    propType: PropTypes.string,
    description: "Currently open question key (controlled)",
    controlType: "text",
    defaultValue: null,
  },
  setOpenQ: {
    propType: PropTypes.func,
    description: "Function to set open question (controlled)",
    disable: true,
  },
};
FAQList.propTypes = AppUtils.getPropTypeFromControls(faqListControls);

export default FAQList;
